import { combineReducers } from 'redux';

const noop = (state = {}) => state;

const rootReducer = combineReducers({
  noop,
});

export default rootReducer;
